export default "__VITE_ASSET__D8ACx790__"